<script>
  import { onMount, createEventDispatcher } from 'svelte';
  import { sortCharacters, getRelationship } from './utilities.js';
  import Cell from './Cell.svelte';

  export let selectedCharacter = {};
  export let selectedRelationship = {};

  let characters = [];
  const dispatch = createEventDispatcher();

  // 0: column headers, 1: row headers
  export let selected_dimension;

  const handleCharacterClick = (character, dimension) => {
    selected_dimension = dimension;
    dispatch('characterPopup', character);
  }

  const isLabelDimmed = (current_char, current_dim, selected_char, selected_rel) => {
    // Check for selected character.
    if (Object.keys(selected_char).length) {
      if (current_char.id == selected_char.id && selected_dimension == current_dim) {
        return false;
      }
      return true;
    }

    // Check for selected relationship.
    if (Object.keys(selected_rel).length) {
      const character_ids = selected_rel.characters.map((item) => item.id);
      if (character_ids[current_dim] != current_char.id) {
        return true;
      }
    }
    return false;
  }

  onMount(async () => {
    const res = await fetch('data/relationships.json');
    characters = sortCharacters(await res.json(), 'i', true);
  });
</script>

<style>
  table {
    border-collapse: collapse;
  }
  th button {
    background: none;
    border: none;
    margin: 0;
    font-size: 12px;
  }
  thead th {
    height: 100px;
    position: relative;
  }
  thead th button {
    position: absolute;
    bottom: 0; left: 2rem;
    width: 120px;
    text-align: left;
    transform: rotate(-45deg);
    transform-origin: 0 100%;
  }
  tbody th {
    text-align: right;
  }
  tbody th button {
    text-align: right;
  }
  tbody td {
    position: relative;
    border: 1px solid #e5e5e7;
  }
  /* tbody td::before {
    position: absolute;
    content: '';
    top: 50%; left: 0; right: 0;
    height: 2px;
    border-top: 1px solid;
    border-top-style: dashed;
    border-top-color: lightgray;
    z-index: -1;
  }
  tbody td::after {
    position: absolute;
    content: '';
    top: 0; bottom: 0; left: 50%;
    width: 2px;
    border-left: 1px solid;
    border-left-style: dashed;
    border-left-color: lightgray;
    z-index: -1;
  } */

  .label {
    transition: .3s ease-in-out;
    letter-spacing: .5px;
    color: #002238;
    padding-top: .5em;
    padding-bottom: .5em;
  }
  .label.dimmed {
    opacity: 0.35;
  }
</style>

{#if characters.length}
<table id="yemen-matrix" class="matrix">
  <thead>
    <tr>
      <th></th>
      {#each characters as character }
        <th id="{character.clean_id}">
          <button class="label" class:dimmed={isLabelDimmed(character, 0, selectedCharacter, selectedRelationship)} on:click="{handleCharacterClick(character, 0)}"><span>{character.name}</span></button>
        </th>
      {/each}
    </tr>
  </thead>
  <tbody>
    {#each characters as character_row }
      <tr>
        <th id="{character_row.clean_id}">
          <button class="label" class:dimmed={isLabelDimmed(character_row, 1, selectedCharacter, selectedRelationship)} on:click="{handleCharacterClick(character_row, 1)}"><span>{character_row.name}</span></button>
        </th>
        {#each characters as character_col }
          <td><Cell relationship={getRelationship(character_col, character_row)} bind:selectedCharacter={selectedCharacter} bind:selectedRelationship={selectedRelationship} bind:selectedDimension={selected_dimension} on:relationshipPopup/></td>
        {/each}
      </tr>
    {/each}
  </tbody>
</table>
{:else}
  <p>Loading...</p>
{/if}
